module.exports = __webpack_public_path__ + "static/media/brandLogo.0929c8a3.svg";